import React, { Component } from 'react';
import { get } from '../services/api';
import Loading from './Loading/Loading';
import PowerfulTable from './PowerfulTable/PowerfulTable';

export default class PassesList extends Component {

  constructor(props) {
    super(props);
    this.state = { passes: undefined, filter: '', filteredPasses: undefined, showCreated: false };
  }

  componentDidMount() {
    this.fetchPasses()
  }

  fetchPasses = async () => {
    // 1. Initial load
    const initialPasses = await get(`/admin/passes?limit=50`);
    if (initialPasses) {
      this.setState({ passes: initialPasses, filteredPasses: initialPasses, filter: '' });
    }

    // 2. Background load
    get(`/admin/passes?limit=10000&skip=50`).then(rest => {
      if (rest && rest.length > 0) {
        this.setState(prevState => {
          const existingIds = new Set((prevState.passes || []).map(p => p.paymentId));
          const newUnique = rest.filter(p => !existingIds.has(p.paymentId));
          const all = [...(prevState.passes || []), ...newUnique];
          return {
            passes: all,
            filteredPasses: all
          };
        }, () => {
          if (this.state.filter) {
            this.applyFilter(this.state.filter);
          }
        });
      }
    });
  }

  applyFilter = (s) => {
    const term = s.toLowerCase();
    const filteredPasses = this.state.passes.filter((p) => {
      return (
        (p.paymentId?.toString().includes(term)) ||
        (p.pupil?.toLowerCase().includes(term)) ||
        (p.status?.toLowerCase().includes(term)) ||
        (p.amount?.toString().includes(term))
      );
    });
    this.setState({ filteredPasses });
  }

  filter = (event) => {
    const s = event.target.value;
    this.setState({ filter: s });
    this.applyFilter(s);
  }

  render() {
    const { filteredPasses, showCreated, filter } = this.state;
    if (!filteredPasses) return <Loading />

    const dataToDisplay = filteredPasses.filter(p => (p.status !== 'created' || showCreated));

    return <div style={{ marginLeft: 20 }}>
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2>Pass ({dataToDisplay.length})</h2>
        <div>
          <label style={{ marginRight: 5 }}>Afficher les achats en cours</label>
          <input type='checkbox' checked={showCreated} onChange={(e) => this.setState({ showCreated: e.target.checked })} />
        </div>
        <div style={{ marginRight: 50 }}>
          <input placeholder='Filtrer...' type='text' onChange={this.filter} value={filter}
            style={{ paddingLeft: 10, width: 180, height: 30, borderRadius: 30, boxShadow: 'none', borderStyle: 'hidden', backgroundColor: '#eee', outline: 'none' }}
          />
        </div>
      </div>

      <PowerfulTable
        data={dataToDisplay}
        types={{
          paymentId: { name: 'id' },
          pupil: { name: 'élève' },
          amount: { name: 'montant (€)' },
          months: { name: 'mois' },
          status: { name: 'statut' },
        }}
        redirect={'passes'}
        redirectKey={'paymentId'}
      />

    </div>
  }
}
